import React from 'react'
import ProgramIncludedAndTrackerCards from './ProgramIncludedAndTrackerCards'


const ProgramIncludedAndTrackerContainer = () => {
    const includedItems = {
        items: [
            {
                id: "01",
                title: "Hormone tests & scans",
                img: "/Programs/OutComes/gynacImage.svg",
            },
            {
                id: "02",
                title: "Ovulation tracking",
                img: "/Programs/OutComes/ovulationImage.svg",
            },
            {
                id: "03",
                title: "Medication (if needed)",
                img: "/Programs/medicationImage.svg",
            },
            {
                id: "04",
                title: "Doctor consultations",
                img: "/Programs/consultationImage.svg",
            }
        ],
        heading: "What's Included"
    }
    const trackItems={
        items:[
            {
                id: "01",
                title: "Weight / metabolism",
                img: "/Programs/cycleImage.svg",
            },
              {
                id: "02",
                title: "Cycle & ovulation",
                img: "/Programs/weightCheckImage.svg",
            },
              {
                id: "03",
                title: "Stress & energy",
                img: "/Programs/stressGirlImage.svg",
            },
              {
                id: "04",
                title: "Progress over time",
                img: "/Programs/OutComes/confidenceImage.svg",
            },
        ],
        heading:"You Track: "
    }
    console.log(includedItems.items, "from parent")
    return (
        <div className='mx-2 my-2 mt-6 sm:mx-6 sm:mt-10 lg:mx-12 lg:mt-20'>
            <div className='flex flex-wrap md:flex-nowrap  items-center flex-row gap-12 justify-center'>
                <ProgramIncludedAndTrackerCards items={includedItems.items} heading={includedItems.heading} />
                <ProgramIncludedAndTrackerCards items={trackItems.items} heading={trackItems.heading} />
            </div>
        </div>
    )
}

export default ProgramIncludedAndTrackerContainer